
<div class="history-card">
  <!-- Player Selector & Filters -->
  <div class="history-controls">
    <div class="player-selector">
      <!-- <label for="selectPlayer">Select Player:</label> -->
      <select id="selectPlayer"
        name="selectPlayer"
        [(ngModel)]="DataService.SelectedPlayer"
        (ngModelChange)="playerChanged($event)">
        @for (player of DataService.Players; track player) {
          <option
            [ngValue]="player">
            {{ player.name }}
          </option>
        }
      </select>
    </div>

    <div class="history-filters">
      <label class="filter-checkbox">
        <input type="checkbox"
          id="SinglesHistory"
          [(ngModel)]="singlesHistory"
          (ngModelChange)="refreshMatchList(DataService.SelectedPlayer.id)">
        <span>Singles</span>
      </label>

      <label class="filter-checkbox">
        <input type="checkbox"
          id="DoublesHistory"
          [(ngModel)]="doublesHistory"
          (ngModelChange)="refreshMatchList(DataService.SelectedPlayer.id)">
        <span>Doubles</span>
      </label>
    </div>
  </div>

  <!-- Player History Table -->
  @if (DataService.SelectedPlayer) {
    <div class="history-table-wrapper">
      <!-- <h2>{{ DataService.SelectedPlayer.name }}</h2> -->
      <p class="match-count">{{ MatchList.length }} matches</p>
      @if (DataService.SelectedPlayer.id > 0) {
        <table class="history-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Tournament</th>
              @if (doublesHistory == true) {
                <th>Partner</th>
              }
              <th>Opponent</th>
              <th>Points Before</th>
              <th>Points After</th>
              <th>Change</th>
              <th>Opp Points Before</th>
              <th>Opp Points After</th>
              <th>Opp Change</th>
              <th>Score</th>
            </tr>
          </thead>
          @for (match of MatchList; track match) {
            <tbody >
              @if (((match.singles && singlesHistory) || (match.doubles && doublesHistory))
                && [match.player1, match.player2, match.player3, match.player4].includes(DataService.SelectedPlayer.id)
                && match.Score1 != '') {
                <tr >
                  <td>{{ match.dateOfMatch | date: 'dd-MM-yyyy' }}</td>
                  <td class="clickable" (click)="gotoTorn(match.Torn)">{{ match.tornName }}</td>
                  <!-- Partner & Opponent logic -->
                  @if (match.player1 == DataService.SelectedPlayer.id && match.doubles) {
                    <td class="clickable" (click)="ViewPlayerHistory(match.player3)">
                      {{ match.doublesPlayer3 }}
                    </td>
                  }
                  @if (match.player2 == DataService.SelectedPlayer.id && match.doubles) {
                    <td class="clickable" (click)="ViewPlayerHistory(match.player4)">
                      {{ match.doublesPlayer4 }}
                    </td>
                  }
                  @if (match.player3 == DataService.SelectedPlayer.id && match.doubles) {
                    <td class="clickable" (click)="ViewPlayerHistory(match.player1)">
                      {{ match.doublesPlayer1 }}
                    </td>
                  }
                  @if (match.player4 == DataService.SelectedPlayer.id && match.doubles) {
                    <td class="clickable" (click)="ViewPlayerHistory(match.player2)">
                      {{ match.doublesPlayer2 }}
                    </td>
                  }
                  @if (match.singles && doublesHistory == true) {
                    <td></td>
                  }
                  <!-- Add other partner/opponent cells as needed, simplified -->
                  @if (match.player1 == DataService.SelectedPlayer.id) {
                    <td class="clickable" (click)="ViewPlayerHistory(match.player2)">
                      {{ match.player2Name }}
                    </td>
                  }
                  @if (match.player2 == DataService.SelectedPlayer.id) {
                    <td class="clickable" (click)="ViewPlayerHistory(match.player1)">
                      {{ match.player1Name }}
                    </td>
                  }
                  @if (match.player3 == DataService.SelectedPlayer.id) {
                    <td class="clickable" (click)="ViewPlayerHistory(match.player2)">
                      {{ match.player2Name }}
                    </td>
                  }
                  @if (match.player4 == DataService.SelectedPlayer.id) {
                    <td class="clickable" (click)="ViewPlayerHistory(match.player1)">
                      {{ match.player1Name }}
                    </td>
                  }
                  <td>{{ match.startPoints1 }}</td>
                  <td>{{ match.newPoints1 }}</td>
                  <td [ngClass]="match.player1Change > 0 ? 'positive' : 'negative'">{{ match.player1Change }}</td>
                  <td>{{ match.startPoints2 }}</td>
                  <td>{{ match.newPoints2 }}</td>
                  <td [ngClass]="match.player2Change > 0 ? 'positive' : 'negative'">{{ match.player2Change }}</td>
                  <td>{{ match.score1 }}</td>
                </tr>
              }
            </tbody>
          }
        </table>
      }
    </div>
  }
</div>


<!-- <div id="HistoryOptions">
<div id="PlayerSelector">
  <select id="selectPlayer" name="selectPlayer" (ngModelChange)="playerChanged($event)" [(ngModel)]="DataService.SelectedPlayer">
    <option *ngFor="let player of DataService.Players" value="{{player.id}}" [ngValue]="player">{{player.name}}</option>
  </select>

</div>
<label class="TypeLabels" for="singles">singles</label><input type="checkbox" id="SinglesHistory" name="singles" value="Singles" [(ngModel)]="singlesHistory" (ngModelChange)="refreshMatchList(DataService.SelectedPlayer.id)" />
<label class="TypeLabels" for="doubles">doubles</label><input type="checkbox" id="DoublesHistory" name="doubles" value="Doubles" [(ngModel)]="doublesHistory" (ngModelChange)="refreshMatchList(DataService.SelectedPlayer.id)" />
</div>
<div id="PlayerHistory" *ngIf="DataService.SelectedPlayer">
  <h2>{{DataService.SelectedPlayer.name}}</h2><label class="TypeLabels">{{MatchList.length}} matches</label>
  <table class="table-layout" id="HistoryTable" #HistoryTable *ngIf="DataService.SelectedPlayer.id > 0">
    <thead>
      <tr>
        <th>Date</th>
        <th>Torn</th>
        <th>Partner</th>
        <th>Opponent</th>
        <th>Points Before</th>
        <th>Points After</th>
        <th>Change</th>
        <th>Opp Points Before</th>
        <th>Opp Points After</th>
        <th>Opp Change</th>
        <th>Score</th>
      </tr>
    </thead>
    <tbody *ngFor="let match of MatchList" >
      <tr *ngIf="((match.singles == true && singlesHistory == true) || (match.doubles == true && doublesHistory == true)) && (match.player1 == DataService.SelectedPlayer.id || match.player2 == DataService.SelectedPlayer.id || match.player3 == DataService.SelectedPlayer.id || match.player4 == DataService.SelectedPlayer.id) && match.Score1 != ''">
        <td>{{match.dateOfMatch | date: 'dd-MM-yyyy'}}</td>
        <td (click)="gotoTorn(match.Torn)">{{match.tornName}}</td>

        <td *ngIf="match.player1 == DataService.SelectedPlayer.id" class="isALink" (click)="ViewPlayerHistory(match.player3)">{{match.doublesPlayer3}}</td>
        <td *ngIf="match.player2 == DataService.SelectedPlayer.id" class="isALink" (click)="ViewPlayerHistory(match.player4)">{{match.doublesPlayer4}}</td>
        <td *ngIf="match.player3 == DataService.SelectedPlayer.id" class="isALink" (click)="ViewPlayerHistory(match.player1)">{{match.doublesPlayer1}}</td>
        <td *ngIf="match.player4 == DataService.SelectedPlayer.id" class="isALink" (click)="ViewPlayerHistory(match.player2)">{{match.doublesPlayer2}}</td>

        <td *ngIf="match.player1 == DataService.SelectedPlayer.id && match.singles" class="isALink" (click)="ViewPlayerHistory(match.player2)">{{match.player2Name}}</td>
        <td *ngIf="match.player2 == DataService.SelectedPlayer.id && match.singles" class="isALink" (click)="ViewPlayerHistory(match.player1)">{{match.player1Name}}</td>
        <td *ngIf="(match.player1 == DataService.SelectedPlayer.id || match.player3 == DataService.SelectedPlayer.id) && match.doubles" class="isALink"><a (click)="ViewPlayerHistory(match.player2)">{{match.doublesPlayer2}}/</a><a (click)="ViewPlayerHistory(match.player4)">{{match.doublesPlayer4}}</a></td>
        <td *ngIf="(match.player2 == DataService.SelectedPlayer.id || match.player4 == DataService.SelectedPlayer.id) && match.doubles" class="isALink"><a (click)="ViewPlayerHistory(match.player1)">{{match.doublesPlayer1}}/</a><a (click)="ViewPlayerHistory(match.player3)">{{match.doublesPlayer3}}</a></td>

        <td *ngIf="match.player1 == DataService.SelectedPlayer.id">{{match.startPoints1}}</td>
        <td *ngIf="match.player2 == DataService.SelectedPlayer.id">{{match.startPoints2}}</td>
        <td *ngIf="match.player3 == DataService.SelectedPlayer.id">{{match.startPoints3}}</td>
        <td *ngIf="match.player4 == DataService.SelectedPlayer.id">{{match.startPoints4}}</td>

        <td *ngIf="match.player1 == DataService.SelectedPlayer.id">{{match.newPoints1}}</td>
        <td *ngIf="match.player2 == DataService.SelectedPlayer.id">{{match.newPoints2}}</td>
        <td *ngIf="match.player3 == DataService.SelectedPlayer.id">{{match.newPoints3}}</td>
        <td *ngIf="match.player4 == DataService.SelectedPlayer.id">{{match.newPoints4}}</td>

        <td *ngIf="match.player1 == DataService.SelectedPlayer.id">{{match.player1Change}}</td>
        <td *ngIf="match.player2 == DataService.SelectedPlayer.id">{{match.player2Change}}</td>
        <td *ngIf="match.player3 == DataService.SelectedPlayer.id">{{match.player3Change}}</td>
        <td *ngIf="match.player4 == DataService.SelectedPlayer.id">{{match.player4Change}}</td>

        <td *ngIf="match.singles && match.player1 == DataService.SelectedPlayer.id">{{match.startPoints2}}</td>
        <td *ngIf="match.singles && match.player2 == DataService.SelectedPlayer.id">{{match.startPoints1}}</td>
        <td *ngIf="match.doubles && (match.player1 == DataService.SelectedPlayer.id || match.player3 == DataService.SelectedPlayer.id)">{{match.startPoints2}}/{{match.startPoints4}}</td>
        <td *ngIf="match.doubles && (match.player2 == DataService.SelectedPlayer.id || match.player4 == DataService.SelectedPlayer.id)">{{match.startPoints1}}/{{match.startPoints3}}</td>

        <td *ngIf="match.singles && match.player1 == DataService.SelectedPlayer.id">{{match.newPoints2}}</td>
        <td *ngIf="match.singles && match.player2 == DataService.SelectedPlayer.id">{{match.newPoints1}}</td>
        <td *ngIf="match.doubles && (match.player1 == DataService.SelectedPlayer.id || match.player3 == DataService.SelectedPlayer.id)">{{match.newPoints2}}/{{match.newPoints4}}</td>
        <td *ngIf="match.doubles && (match.player2 == DataService.SelectedPlayer.id || match.player4 == DataService.SelectedPlayer.id)">{{match.newPoints1}}/{{match.newPoints3}}</td>

        <td *ngIf="match.singles && match.player1 == DataService.SelectedPlayer.id">{{match.player2Change}}</td>
        <td *ngIf="match.singles && match.player2 == DataService.SelectedPlayer.id">{{match.player1Change}}</td>
        <td *ngIf="match.doubles && (match.player1 == DataService.SelectedPlayer.id || match.player3 == DataService.SelectedPlayer.id)">{{match.player2Change}}</td>
        <td *ngIf="match.doubles && (match.player2 == DataService.SelectedPlayer.id || match.player4 == DataService.SelectedPlayer.id)">{{match.player1Change}}</td>

        <td *ngIf="match.player1 == DataService.SelectedPlayer.id || match.player3 == DataService.SelectedPlayer.id">{{match.score1}}</td>
        <td *ngIf="match.player2 == DataService.SelectedPlayer.id || match.player4 == DataService.SelectedPlayer.id">{{match.score2}}</td>
      </tr>
    </tbody>
  </table>
</div> -->
